<template>
    <div class="d-flex flex-wrap p-0 col-11">

            <div class="d-flex flex-wrap col-12 p-0 mr-3 mt-3">
                  <form-field :label="getFieldLabel('age') + ', лет'"
                              class="col-xs-12 col-sm-5 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                              :value="object.age"
                              :editable="isEditable('age')"
                              :feedback="liveFeedback('age')">
                          <template #field>
                                  <b-input
                                      id="age"
                                      class="w-100"
                                       v-model="$v.form.age.$model"
                                      :state="validateState('age')">
                                  </b-input>
                          </template>
                  </form-field>

                  <form-field :label="getFieldLabel('weight') + ', кг'"
                              class="col-xs-12 col-sm-6 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                              :value="object.weight"
                              :editable="isEditable('weight')"
                              :feedback="liveFeedback('weight')">
                          <template #field>
                                  <b-input
                                      id="weight"
                                      class="w-100"
                                       v-model="$v.form.weight.$model"
                                      :state="validateState('weight')">
                                  </b-input>
                          </template>
                  </form-field>

                  <form-field :label="getFieldLabel('height') + ', см'"
                              class="col-xs-12 col-sm-5 col-md-4 col-lg-3 p-0 mr-3 mt-3"
                              :value="object.height"
                              :editable="isEditable('height')"
                              :feedback="liveFeedback('height')">
                          <template #field>
                                  <b-input
                                      id="height"
                                      class="w-100"
                                       v-model="$v.form.height.$model"
                                      :state="validateState('height')">
                                  </b-input>
                          </template>
                  </form-field>
            </div>

            <div class="d-flex flex-wrap col-12 p-0 mr-3 mt-3">
              <form-field :label="getFieldLabel('colorGroupList')"
                          class="col-xs-12 col-sm-12 col-md-6 col-lg-4 p-0 mr-3 mt-3"
                          :value="object.colorGroupNames"
                          :editable="isEditable('colorGroupList')"
                          :feedback="liveFeedback('colorGroupList')">
                      <template #field>
                          <list-select name="colorGroupList"
                                       v-model="form['colorGroupObjects']"
                                       :url="colorGroupsUrl"
                                       :label="getFieldLabel('colorGroupList')"
                                       :state="getValidationClass('colorGroupList')"
                                       can-remove-key="can_remove"
                                       :has-search="false"
                                       v-on:select-added="onColorGroupObjectListAdded"
                                       v-on:select-removed="onColorGroupObjectListRemoved"  />
                      </template>
              </form-field>

              <form-field v-if="form['colorGroupList'] && form['colorGroupList'].length > 0" :label="getFieldLabel('color')"
                          class="col-xs-12 col-sm-12 col-md-6 col-lg-4 p-0 mr-3 mt-3"
                          :value="object.color"
                          :editable="isEditable('color')"
                          :feedback="liveFeedback('color')">
                      <template #field>
                              <b-input
                                  id="color"
                                  class="w-100"
                                   v-model="$v.form.color.$model"
                                  :state="validateState('color')">
                              </b-input>
                      </template>
              </form-field>
            </div>

           <div class="d-flex flex-wrap col-12 p-0 mr-3 mt-3">
              <form-field class="col-xs-12 col-sm-6 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                           :label="getFieldLabel('gender')"
                           :editable="getAbility('gender')"
                           :value="object.genderName"
                           :feedback="liveFeedback('gender')">
                  <template #field>
                      <radio-list id="gender" name="gender"
                                  v-model="form.gender" :url="getGendersUrl"
                                  @radio-changed="onModelObjectRadioChanged"/>
                  </template>
              </form-field>

              <form-field :label="getFieldLabel('hairType')"
                          class="col-xs-12 col-sm-6 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                          :value="object.hairTypeText"
                          :editable="isEditable('hairType')"
                          :feedback="liveFeedback('hairType')">
                      <template #field>
                          <radio-list id="hairType" name="hairType"
                              v-model="form.hairType" :url="hairTypesUrl"
                              @radio-changed="onModelObjectRadioChanged"/>
                      </template>
              </form-field>

              <form-field :label="getFieldLabel('earCrop')"
                          class="col-xs-12 col-sm-5 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                          :value="object.earCropText"
                          :editable="isEditable('earCrop')"
                          :feedback="liveFeedback('earCrop')">
                      <template #field>
                          <radio-list id="earCrop" name="earCrop"
                              v-model="form.earCrop" :url="earCropUrl"
                              @radio-changed="onModelObjectRadioChanged"/>
                      </template>
              </form-field>

              <form-field :label="getFieldLabel('tailCrop')"
                          class="col-xs-12 col-sm-6 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                          :value="object.tailCropText"
                          :editable="isEditable('tailCrop')"
                          :feedback="liveFeedback('tailCrop')">
                      <template #field>
                          <radio-list id="tailCrop" name="tailCrop"
                              v-model="form.tailCrop" :url="tailCropUrl"
                              @radio-changed="onModelObjectRadioChanged"/>
                      </template>
              </form-field>
           </div>

            <div class="d-flex col-12 p-0 mr-3 mt-3 flex-wrap">
                <form-field class="d-flex col-xs-12 col-sm-12 col-md-4 col-lg-3 col-xl-2 p-0 mb-2"
                            :label="getFieldLabel('earlySterilization')"
                            :value="object.earlySterilization ? 'Да' : 'Нет'"
                            :editable="isEditable('earlySterilization')"
                            :feedback="liveFeedback('earlySterilization')">
                        <template #field>
                            <b-form-checkbox  size="lg" v-model="form.earlySterilization" @change="onEarlySterilizationChange" switch >
                                <span v-if="form.earlySterilization">Да</span>
                                <span v-else>Нет</span>
                            </b-form-checkbox>
                        </template>
                </form-field>

                <form-field v-if="form.earlySterilization"
                            class="d-flex col-xs-12 col-sm-12 col-md-8 col-lg-5 p-0"
                            :label="getFieldLabel('earlySterilizationDate')"
                            :value="object.earlySterilizationDate"
                            :editable="isEditable('earlySterilizationDate')"
                            :feedback="liveFeedback('earlySterilizationDate')">
                        <template #field>
                            <date-time-picker class="w-100"
                                      ref="earlySterilizationDate"
                                      name="earlySterilizationDate"
                                      :editable="isEditable('earlySterilizationDate')"
                                      :show-timepicker="false"
                                      :date-required="false"
                                      :key="getEarlySterilizationDate()"
                                      :state="validateState('earlySterilizationDate')"
                                      :initial-date-string="getEarlySterilizationDate()"
                                      @date-changed="onModelDateChanged" />
                        </template>
                </form-field>
            </div>

            <form-field :label="getFieldLabel('distinctive')"
                        class="col-xs-12 col-sm-12 col-md-6 p-0 mr-3 mt-3"
                        :value="object.distinctive"
                        :editable="isEditable('distinctive')"
                        :feedback="liveFeedback('distinctive')">
                    <template #field>
                            <b-form-textarea
                                id="distinctive"
                                class="w-100"
                                 v-model="$v.form.distinctive.$model"
                                :state="validateState('distinctive')">
                            </b-form-textarea>
                    </template>
            </form-field>

            <form-field :label="getFieldLabel('ownerSigns')"
                        class="col-xs-12 col-sm-12 col-md-5 p-0 mr-3 mt-3"
                        :value="object.ownerSigns"
                        :editable="isEditable('ownerSigns')"
                        :feedback="liveFeedback('ownerSigns')">
                    <template #field>
                            <b-form-textarea
                                id="ownerSigns"
                                class="w-100"
                                 v-model="$v.form.ownerSigns.$model"
                                :state="validateState('ownerSigns')">
                            </b-form-textarea>
                    </template>
            </form-field>

            <form-field :label="getFieldLabel('labelId')"
                        class="col-xs-12 col-sm-5 col-md-4 col-lg-3 p-0 mr-3 mt-3"
                        :value="object.labelId"
                        :editable="isEditable('labelId')"
                        :feedback="liveFeedback('labelId')">
                    <template #field>
                            <b-input
                                id="labelId"
                                class="w-100"
                                 v-model="$v.form.labelId.$model"
                                :state="validateState('labelId')">
                            </b-input>
                    </template>
            </form-field>

            <form-field :label="getFieldLabel('chipId')"
                        class="col-xs-12 col-sm-6 col-md-4 col-lg-3 p-0 mr-3 mt-3"
                        :value="object.chipId"
                        :editable="isEditable('chipId')"
                        :feedback="liveFeedback('chipId')">
                    <template #field>
                            <b-input
                                id="chipId"
                                class="w-100"
                                 v-model="$v.form.chipId.$model"
                                :state="validateState('chipId')">
                            </b-input>
                    </template>
            </form-field>

            <form-field class="col-xs-12 col-sm-6 col-md-3 col-lg-2 p-0 mr-3 mt-3"
                        :label="getFieldLabel('repeatedCatching')"
                        :value="object.repeatedCatching ? 'Да' : 'Нет'"
                        :editable="isEditable('repeatedCatching')"
                        :feedback="liveFeedback('repeatedCatching')">
                    <template #field>
                        <b-form-checkbox  size="lg" v-model="form.repeatedCatching" @change="onRepeatedCatchingChange" switch >
                            <span v-if="form.repeatedCatching">Да</span>
                            <span v-else>Нет</span>
                        </b-form-checkbox>
                    </template>
            </form-field>


            <form-field :label="getFieldLabel('results')"
                        class="col-xs-12 col-sm-12 col-md-6 p-0 mr-3 mt-3"
                        :value="object.results"
                        :editable="isEditable('results')"
                        :feedback="liveFeedback('results')">
                    <template #field>
                            <b-form-textarea
                                id="results"
                                class="w-100"
                                 v-model="$v.form.results.$model"
                                :state="validateState('results')">
                            </b-form-textarea>
                    </template>
            </form-field>

            <form-field :label="getFieldLabel('vetHelp')"
                        class="col-xs-12 col-sm-12 col-md-5 p-0 mr-3 mt-3"
                        :value="object.vetHelp"
                        :editable="isEditable('vetHelp')"
                        :feedback="liveFeedback('vetHelp')">
                    <template #field>
                            <b-form-textarea
                                id="vetHelp"
                                class="w-100"
                                 v-model="$v.form.vetHelp.$model"
                                :state="validateState('vetHelp')">
                            </b-form-textarea>
                    </template>
            </form-field>

            <form-field :label="getFieldLabel('conclusion')"
                        class="col-xs-12 col-sm-12 col-md-5 p-0 mr-3 mt-3"
                        :value="object.conclusion"
                        :editable="isEditable('conclusion')"
                        :feedback="liveFeedback('conclusion')">
                    <template #field>
                            <b-form-textarea
                                id="conclusion"
                                class="w-100"
                                 v-model="$v.form.conclusion.$model"
                                :state="validateState('conclusion')">
                            </b-form-textarea>
                    </template>
            </form-field>

            <form-field :label="getFieldLabel('comment')"
                class="col-xs-12 col-sm-12 col-md-5 p-0 mr-3 mt-3"
                :value="object.comment"
                :editable="isEditable('comment')"
                :feedback="liveFeedback('comment')">
                <template #field>
                        <b-textarea
                            id="comment"
                            class="w-100"
                             v-model="$v.form.comment.$model"
                            :state="validateState('comment')">
                        </b-textarea>
                </template>
            </form-field>

            <form-field :label="getFieldLabel('vetSpecialist')"
                        class="col-xs-12 col-sm-12 col-lg-8 p-0 mr-3 mt-3"
                        :value="object.vetSpecialist"
                        :editable="isEditable('vetSpecialist')"
                        :feedback="liveFeedback('vetSpecialist')">
                    <template #field>
                            <b-input
                                id="vetSpecialist"
                                class="w-100"
                                 v-model="$v.form.vetSpecialist.$model"
                                :state="validateState('vetSpecialist')">
                            </b-input>
                    </template>
            </form-field>

    </div>


</template>

<script>
    import FormField from "../../../../components/Forms/FormField";
    import { ObjectComponentMixin } from "../../../../components/Forms/ObjectComponentMixin";
    import {InitialEventAttributes} from "./initial";
    import api from "../../../../api";
    import RadioList from "@/components/Select/RadioList";
    import {AttributeMixin} from "@/pages/AppPages/Events/AttributeMixin";
    import {mapGetters} from "vuex";
    import DateTimePicker from "@/components/Forms/DateTimePicker.vue";
    import ListSelect from "@/components/Select/ListSelect.vue";

    export default {
        name: "InitialAttributes",
        components: {ListSelect, DateTimePicker, RadioList, FormField },
        mixins: [ObjectComponentMixin, AttributeMixin],
        computed: {
            ...mapGetters(['userLastValidContract']),
            hairTypesUrl() { return api.animals.hairTypes.list(api.animals.default.list()) },
            earCropUrl() { return api.animals.earCrop.list(api.animals.default.list()) },
            tailCropUrl() { return api.animals.tailCrop.list(api.animals.default.list()) },
            getGendersUrl() { return api.animals.genders.list(); },
            colorGroupsUrl() { return api.animals.colorGroups.list(); },
        },
        methods: {
            getEarlySterilizationDate() {
                return this.object.earlySterilizationDate;
            },
            onEarlySterilizationChange() {
                this.$v.form.earlySterilization.$touch();
                if (!this.form.earlySterilization) {
                    this.form.earlySterilizationDate = null;
                }
            },
            onRepeatedCatchingChange() {
                this.$v.form.repeatedCatching.$touch();
            },
            onColorGroupObjectListAdded(name, item) {
              this.onModelObjectListAdded(name, item)
              if (!this.form['color']) {
                this.form['color'] = item['default_color_value']
              }
            },
            onColorGroupObjectListRemoved(name, item) {
              this.onModelObjectListRemoved(name, item)
              if (this.form['colorGroupList'] && this.form['colorGroupList'].length === 0) {
                this.form['color'] = null
              }
            }
        },
        beforeMount() {
            this.objectClass = InitialEventAttributes;
            this.initialize();
        },
        mounted() {
            this.onMount();
            this.resetForm();
        },
    }
</script>

<style scoped>

</style>